declare namespace $ {

	export class $mol_icon_currency_rub extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=rub.view.tree.d.ts.map